import '@sass/dashboard.scss';
import Vue, {Component} from 'vue';
import '@advisor/globalComponents';
import '@advisor/bootstrap';
import 'bootstrap';
import '@advisor/plugins';
import store from '@advisor/store';
import router from '@advisor/router';
import {bootstrapApp as registerAnalytics} from '@advisor/util/common/analytics';
import {initialize as initializeInterceptors} from '@advisor/interceptors';
import {Environment, init as initAuth} from '@simpleinvest/front-end-auth';
import vuetify from '@advisor/plugins/vuetify';
import App from '@advisor/components/App.vue';
import customValidators from '@advisor/util/customValidators';
import {init} from './frontendutils/init';

console.log('Release version:', process.env.PACKAGE_VERSION);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare let window: any;

initAuth({
  region: process.env.VUE_APP_REGION,
  env: process.env.VUE_APP_ENV as Environment,
  userPoolId: process.env.VUE_APP_COGNITO_USERPOOL_ID,
  userPoolWebClientId: process.env.VUE_APP_COGNITO_CLIENT_ID || 'invalid',
});

init({
  env: process.env.VUE_APP_ENV as Environment,
  release: `Advisor-${process.env.PACKAGE_VERSION}`,
});

initializeInterceptors(store, router);
customValidators();

new Vue({
  name: 'AdvisorApp',
  router,
  store,
  vuetify,
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  beforeCreate() {
    registerAnalytics();
  },
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render: (h) => h(App as Component),
}).$mount('#app');

window.Vue = Vue;
Vue.config.productionTip = false;
